module.exports = __webpack_public_path__ + "static/media/dataset-3.29d05b1a.PNG";